import './HArticleTemplate.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { HText } from '../HText';
import { HHeading } from '../HHeading';
import { HLeadText } from '../HLeadText';
import { HMedia } from '../HMedia';
import { HLinkButtonList } from '../HLinkButton';
import { HTableOfContents, TableOfContentsItem } from '../HTableOfContents';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import {
  AvailableLanguage,
  ArticleTemplateModule,
  NAVIGATION_PREFIX,
} from '~/schemes';
import { HKeyVisualModule } from '~/components';

export const HArticleTemplate = tsx.component({
  name: 'HArticleTemplate',
  functional: true,

  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          ArticleTemplateModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },

    /**
     * コンテナクラスの付与を無効にする場合に指定する
     */
    disableContainer: Boolean,
  },

  render(h, { props, data }): VNode {
    const {
      headerType,
      keyVisualHeader,
      headingHeader,
      leadText,
      articleContentList,
      showToc,
      showSectionLine,
      tocStyle,
      linkButtonList,
    } = props.value;

    const getHeadingText = (child: typeof articleContentList[0]): string => {
      const body = child.properties.heading.properties.body;
      return body && body.text ? body.text : '';
    };

    const tocItems: TableOfContentsItem[] = articleContentList
      .map((child, index) => ({
        id: `${NAVIGATION_PREFIX}${index + 1}`,
        text: getHeadingText(child),
      }))
      .filter((item) => item.text !== '');

    const hasLinkButtons =
      linkButtonList &&
      linkButtonList.properties &&
      linkButtonList.properties.children &&
      !!linkButtonList.properties.children.length;

    return (
      <div staticClass="h-article-template-module">
        {/* ヘッダー部分 (KeyVisual または Heading) */}
        {headerType === 'Heading'
          ? headingHeader &&
            headingHeader.properties && (
              <div staticClass="h-article-template-module__heading-header">
                <HHeading value={headingHeader.properties} />
              </div>
            )
          : keyVisualHeader &&
            keyVisualHeader.properties && (
              <HKeyVisualModule properties={keyVisualHeader.properties} />
            )}

        {/* リードテキスト */}
        {leadText && leadText.properties && (
          <HLeadText value={leadText.properties} />
        )}
        <div>
          {/* 目次 */}
          {showToc && !!tocItems.length && (
            <HTableOfContents items={tocItems} tocStyle={tocStyle} />
          )}

          {articleContentList.map((child, index) => {
            return (
              <div
                staticClass="h-article-template-module__article-content"
                class={{
                  'h-article-template-module__article-content--with-border': showSectionLine,
                }}
                id={`${NAVIGATION_PREFIX}${index + 1}`}>
                <HHeading value={child.properties.heading.properties} />
                {child.properties.mediaWithTextList.map((mediaWithText) => (
                  <div staticClass="h-article-template-module__media-with-text">
                    <HMedia value={mediaWithText.properties.media.properties} />
                    <HText value={mediaWithText.properties.text.properties} />
                  </div>
                ))}
              </div>
            );
          })}
        </div>

        {/* リンクボタンリスト */}
        {hasLinkButtons && (
          <HLinkButtonList value={linkButtonList.properties} />
        )}
      </div>
    );
  },
});
